// extracted by mini-css-extract-plugin
export var content = "_an-3";
export var list = "_an-4";
export var settingsContent = "_an-7";
export var settingsPanel = "_an-8";
export var state = "_an-6";
export var triggerBadge = "_an-2";
export var triggerButton = "_an-1";
export var triggerShell = "_an-0";
export var unreadDot = "_an-5";